import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "center-x tablet:position-reset fixed top-8 z-[100] w-full max-w-[95%] rounded-4 border border-dashed border-black-300 bg-black-100 px-8 py-12 text-center text-black-900 shadow-custom-discount tablet:!right-8 tablet:!top-8 tablet:w-fit tablet:px-24"
}
const _hoisted_2 = { class: "text-16 leading-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      ($data.showPopup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString($data.locale.discount_activated), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}